import React, { Component } from "react";
import DebouncedInput from "components/Common/DebouncedInput";
import LoginSplash from "components/Common/LoginSplash";
import PropTypes from "prop-types";
import "./style.scss";

export class MFAPhoneNumberForm extends Component {
  /**
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.handleCountryCodeChange = this.handleCountryCodeChange.bind(this);
    this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
  }

  /**
   * @param {String} value
   */
  handleCountryCodeChange(value) {
    const { handleInputChange } = this.props;
    handleInputChange("countryCode", value);
  }

  /**
   * @param {String} value
   */
  handlePhoneNumberChange(value) {
    const { handleInputChange } = this.props;
    handleInputChange("phoneNumber", value);
  }

  /**
   * @returns {HTMLElement}
   */
  render() {
    const {
      buttonIsDisabled,
      buttonIsLoading,
      countryCode,
      currentStep,
      errorMessage,
      onClick,
      phoneNumber,
      resetNotificationError
    } = this.props;

    if (currentStep !== 2) {
      return null;
    }

    return (
      <LoginSplash
        title="Add Your Phone Number"
        button={{
          label: "Send Code",
          action: () => onClick(),
          isLoading: buttonIsLoading,
          disabled: buttonIsDisabled
        }}
        showError={errorMessage.length > 0}
        description="We’ll send verification code via SMS to verify your phone number."
        resetNotificationError={resetNotificationError}
        errorMessage={errorMessage}

      >
        <div className="MFAPhoneNumberForm">
          <div>
            <label
              className="g-form__block__label"
              htmlFor="PhoneNumberForm__countryCode"
            >
              Country Code
            </label>
            <DebouncedInput
              name="countryCode"
              placeholder="+1"
              value={countryCode}
              onChange={this.handleCountryCodeChange}
              id="PhoneNumberForm__countryCode"
            />
          </div>

          <div>
            <label
              className="g-form__block__label"
              htmlFor="PhoneNumberForm__phoneNumber"
            >
              Phone Number
            </label>
            <DebouncedInput
              id="PhoneNumberForm__phoneNumber"
              name="phoneNumber"
              placeholder="(123) 456-7890"
              type="tel"
              value={phoneNumber}
              onChange={this.handlePhoneNumberChange}
            />
          </div>
        </div>
      </LoginSplash>
    );
  }
}

MFAPhoneNumberForm.propTypes = {
  onClick: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  buttonIsLoading: PropTypes.bool.isRequired,
  buttonIsDisabled: PropTypes.bool.isRequired,
  resetNotificationError: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired
};
